import "core-js/modules/web.dom.iterable";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '0px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {// setTimeout(() => {
    // this.initBarChart()
    // }, 1000)
    // this.$nextTick(() => {})s
  },
  methods: {
    initBarChart: function initBarChart(dataArr, dateStr) {
      //	趋势图
      var arrs = [];
      var shandian = 'image://data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAOCAMAAADKSsaaAAAAclBMVEUAAACAAADMAAC2AAC/AADIAADMAADRAADKAADMCAjPCAjJBwfMBgbLBgbNBgbLBQXLBQXNCQnMCAjOCQnMCAjNCQnMCQnPCgrNCgrOCQnOCwvNCgrOCgrOCgrOCgrNCgrOCwvOCgrNCgrOCgrOCgrOCwto2NwFAAAAJXRSTlMAAgUHCA4UFhgeICYoLC4xNjhBVHmKjZmvvcLO3+Hj7O/4+/3+bk5NRAAAAE5JREFUCB0FwQkCgQAABMBBFHIU5Qqh/f8XzQDzI8C9AfRTDZx+qcAhSQHrMXnB8pEkyUU3DJ8ktwW8k2cJRfLdglXSApvpDNhfZ4Ad8AeiCgXoDXM13gAAAABJRU5ErkJggg==';
      var path = ['', shandian, '', shandian, '', shandian];
      var todayData = [502.84, 205.97, 332.79, 281.55, 398.35, 214.02];
      var markProfile = todayData.map(function (item, index) {
        return {
          coord: [index, item]
        };
      });

      function getSeries(datas) {
        datas.forEach(function (item, index) {
          var obj = {
            name: item.title,
            type: 'line',
            smooth: true,
            //是否平滑
            showAllSymbol: true,
            // symbol: 'image://./static/images/guang-circle.png',
            symbol: 'circle',
            symbolSize: 10,
            // lineStyle: {
            //     normal: {
            //         color: "#FFBC0D",
            //         shadowColor: 'rgba(0, 0, 0, 0)',
            //         shadowBlur: 0,
            //         shadowOffsetY: 5,
            //         shadowOffsetX: 5,
            //     },
            // },
            label: {
              show: false,
              position: 'top',
              textStyle: {
                color: '#FFF',
                fontSize: 14
              }
            },
            // itemStyle: {
            //     color: "#FFBC0D",
            //     borderColor: "rgb(108,78,0)",
            //     borderWidth: 0,
            //     shadowColor: 'rgba(0, 0, 0, 0)',
            //     shadowBlur: 0,
            //     shadowOffsetY: 0,
            //     shadowOffsetX: 0,
            // },
            tooltip: {
              show: true
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(255,188,13, 0.4)'
                }, {
                  offset: 1,
                  color: 'rgba(255,188,13, 0)'
                }],
                global: false // 缺省为 false

              }
            },
            data: item.data
          };
          arrs.push(obj);
        });
      }

      var option = {
        //   backgroundColor: '#080b30',
        title: {
          show: false,
          text: '多线图',
          textStyle: {
            align: 'center',
            color: '#fff',
            fontSize: 20
          },
          top: '5%',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(0, 255, 233,0)'
                }, {
                  offset: 0.5,
                  color: 'rgba(255, 255, 255,1)'
                }, {
                  offset: 1,
                  color: 'rgba(0, 255, 233,0)'
                }],
                global: false
              }
            }
          }
        },
        grid: {
          top: '5%',
          left: '5%',
          right: '5%',
          bottom: '5%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          axisLine: {
            show: true
          },
          splitArea: {
            // show: true,
            color: '#f00',
            lineStyle: {
              color: '#f00'
            }
          },
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            show: false
          },
          boundaryGap: false,
          data: dateStr
        }],
        yAxis: [{
          type: 'value',
          // min: 0,
          // max: 140,
          splitNumber: 4,
          splitLine: {
            show: true,
            lineStyle: {
              color: ['#fff'],
              opacity: 0.06
            }
          },
          axisLine: {
            show: false
          },
          axisLabel: {
            show: true,
            margin: 20,
            textStyle: {
              fontSize: 12,
              color: 'rgba(255,255,255,0.5)'
            }
          },
          axisTick: {
            show: false
          }
        }],
        series: arrs
      };
      var chart = this.$refs[this.chart];
      setTimeout(function () {
        getSeries(dataArr);
        myChart.setOption(option);
      }, 10);
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      });
    }
  }
};